/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {useState, useMemo} from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { ViewModelForm, useDataRefresh } from '@xengage/gw-portals-viewmodel-react';
import { withRouter } from 'react-router-dom';
import { MLDriverVehicleUtil } from 'ml-portals-util-react';
import { useTranslator } from '@jutro/locale';
import appConfig from 'app-config';
import { DateInput } from '@jutro/components/new';
import { MLProductCodeUtil } from 'ml-portals-util-js';
import messages from "ml-components-common-react/MLPAAgentEditVehicleComponent/MLPAAgentEditVehicleComponent.messages";
import metadata from './MLCRVehiclesNonDiscrepanciesComponent.metadata.json5';
import moment from 'moment';
import MLPARegisteredOwnersComponent from 'ml-components-common-react/MLPARegisteredOwnersComponent/MLPARegisteredOwnersComponent';
function MLCRVehiclesNonDiscrepanciesComponent(props) {
    const { vehicleVM, submissionVM, onValidate, showValidationErrors } = props;
    const { refreshData } = useDataRefresh();
    const translator = useTranslator();

    const {
        canDisplayAnnualMileage,
    } = MLDriverVehicleUtil();

    const [showOwnedLessThan6Months, setShowOwnedLessThan6Months] = useState(false);

    const policyAddress = _.get(submissionVM, 'baseData.policyAddress.value', {});
    const effectiveDate = _.get(submissionVM, 'baseData.periodStartDate.value', {});
    const showPurchaseDateMonths = () => policyAddress.state === 'NY' || policyAddress.state === 'NJ';

    // Parking Type - where you park your vehicle
    const isVehicleOfCategory = (category) => {
        return category === _.get(vehicleVM, 'category_ML.value.code', '');
    };
    const isPrivatePassenger = () => isVehicleOfCategory('private_passenger_light_truck');
    const isPrivatePassengerNP = () => isVehicleOfCategory('private_passenger_np');
    const isCollectible = () => isVehicleOfCategory('collectible');
    const isOtherPersonallyRegistered = () => isVehicleOfCategory('Other_Personally_Registered');
    const isWhereParkedRequired = () => isPrivatePassenger() || isCollectible() || isPrivatePassengerNP();
    //new product
    const isModernProduct = _.get(submissionVM, "isModernProduct_Ext.value", false);
    const isModernProductPersonalAuto = isModernProduct && MLProductCodeUtil.isPersonalAuto(_.get(submissionVM, 'baseData.productCode.value'));
    const isVehicleYearPre1981 = () => vehicleVM.value.year && vehicleVM.value.year < 1981 && vehicleVM.value.year > 1969;
    
    const vehicleType = _.get(vehicleVM, 'type_ML.value.code');
    const FARM_ALLOWED_VEHICLE_TYPES = ['4wd_pickup_np', '2wd_truck_np'];

    const getPrimaryUseAvailableValues = (vehicleType) => {
        const baseValues = [
            {
                code: 'pleasure',
                name: {
                    id: 'ml.quoteandbind.pa.agent.editVehicle.pleasure.np',
                    defaultMessage: 'Pleasure'
                }
            },
            {
                code: 'business',
                name: {
                    id: 'ml.quoteandbind.pa.agent.editVehicle.business.np',
                    defaultMessage: 'Business'
                }
            },
            {
                code: 'storage_np',
                name: {
                    id: 'ml.quoteandbind.pa.agent.editVehicle.storage.np',
                    defaultMessage: 'Storage'
                }
            }
        ];

        if ((FARM_ALLOWED_VEHICLE_TYPES.includes(vehicleType) && !!vehicleType && isModernProductPersonalAuto) || (_.get(vehicleVM, 'primaryUse.value') === 'farm_np') )
            baseValues.push({
                code: 'farm_np',
                name: {
                    id: 'ml.quoteandbind.pa.agent.editVehicle.FarmNP.np',
                    defaultMessage: 'Farm'
                }
            });

        return baseValues;
    };
    const [primaryUseAvailableValues, setPrimaryUseAvailableValues] = useState(
        getPrimaryUseAvailableValues(vehicleType)
    );

    // Annual Mileage
    const isAnnualMileageRequiredByType = () => {
        return !!((isPrivatePassenger() || isPrivatePassengerNP()) && canDisplayAnnualMileage(vehicleVM));
    };

    const isDisputedVendorMileage = () => {
        return vehicleVM?.value?.disputedVendorAnnualMileage_Ext;
    };

    const annualMileageValue = () => {
        if (_.get(vehicleVM, 'hasVendorAnnualMileage.value') && !_.get(vehicleVM, 'disputedVendorAnnualMileage_Ext.value')) {
            return null
        }

        return _.get(vehicleVM, 'annualMileage.value')
    }

    // Viewmodel form
    const handleValueChange = (value, path) => {
        if (path === 'annualMileage') {
            vehicleVM.annualMileage.value = value;
        } else if (path === 'parkingType_ML') {
            vehicleVM.parkingType_ML.value = value;
        }

        refreshData();
    }

    const handleVehicleModelChange = () => {
        refreshData();
    }

    const checkOwnedLessThanSixMonths = () => {
        if (!vehicleVM.purchaseDate_ML.value) {
            setShowOwnedLessThan6Months(false);
            vehicleVM.ownedLessThan6Months_Ext.value = false;

            return;
        }

        const effectiveMonth = effectiveDate.month + 1;
        const currentYear = new Date().getFullYear();

        if (vehicleVM.purchaseDate_ML.value.year === currentYear - 1) {
            if (effectiveMonth < 6) {
                setShowOwnedLessThan6Months(true);
            } else {
                setShowOwnedLessThan6Months(false);
                vehicleVM.ownedLessThan6Months_Ext.value = false;
            }
        } else if (vehicleVM.purchaseDate_ML.value.year === currentYear) {
            if (effectiveMonth > 6) {
                setShowOwnedLessThan6Months(true);
            } else {
                setShowOwnedLessThan6Months(false);
                vehicleVM.ownedLessThan6Months_Ext.value = true;
            }
        } else {
            setShowOwnedLessThan6Months(false);
            vehicleVM.ownedLessThan6Months_Ext.value = false;
        }
    };

    const updatePurchaseDate = (value) => {
        // handle string value from purchaseYear dropdown
        if (typeof value === 'string') {
            vehicleVM.purchaseDate_ML.value = {
                year: parseInt(value),
                day: 1
            };
        } else {
            vehicleVM.purchaseDate_ML.value = value
        }

        if (!showPurchaseDateMonths()) {
            checkOwnedLessThanSixMonths();
        }

        refreshData();
    };

    const getCarPurchaseAvailableYears = () => {
        const currentYear = new Date().getUTCFullYear();
        const { oldestCarYear } = appConfig.personalAutoConfig;
        // _.range is not inclusive. Need to add -1 to get correct years
        const yearRange = _.range(currentYear, oldestCarYear - 1);
        const years = yearRange.map(_.toString).map((year) => ({
            code: year,
            name: year
        }));

        return years;
    };

    //Handles changes of the vehicle purchase date input
    const handleDateChange = (e) => {
        _.set(vehicleVM, 'vehiclePurchaseDate.value', e.target.value);
        refreshData();
    }

    const checkDate = (dateValue) => {
        const vPurchaseDate = dateValue;
        if (!vPurchaseDate?.day || !vPurchaseDate?.month || !vPurchaseDate?.year) { return true; }
        const selected = new Date(vPurchaseDate?.year, vPurchaseDate?.month - 1, vPurchaseDate?.day);
        const today = new Date();
        const maxDate = new Date();
        maxDate.setDate(today.getDate() + 7);
        if (selected > maxDate) {
            return true;
        }
        const validDate = moment(
            { year: vPurchaseDate.year, month: vPurchaseDate.month - 1, day: vPurchaseDate.day },
            true).isValid();
        if (!validDate) return true;
        return false;
    }

    const vehiclePurchaseDateValue = _.get(vehicleVM, 'vehiclePurchaseDate.value');


    const drivers = submissionVM?.lobData?.personalAuto?.coverables?.drivers?.value ?? [];
    const saved = _.get(vehicleVM, 'registeredOwners.value', []);

    const initialRegisteredOwners = Array.isArray(saved)
        ? saved.map(s => {
            const id = String(s.driverID ?? s.fixedId);
            const d = drivers.find(dr => String(dr.fixedId) === id);
            if (!d) return null;
            return {
                id,
                label: d.displayFullName_Ext || d.displayName,
            };
        }).filter(Boolean) : [];
    const [registeredOwnersValue, setRegisteredOwnersValue] = useState(initialRegisteredOwners);

    const handleOwnerChange = (selectedOptions) => {
        setRegisteredOwnersValue(selectedOptions);
        const selectedIds = (selectedOptions || []).map(o => String(o.id));
        const selectedDrivers = drivers
            .filter(d => selectedIds.includes(String(d.fixedId)))
            .map(d => ({
                fixedId: d.fixedId,
                displayName: d.displayFullName_Ext || d.displayName,
                driverID: d.fixedId,
            }));
        _.set(vehicleVM, 'registeredOwners.value', selectedDrivers);
    };


    const overrideProps = {
        purchaseYearField: {
            availableValues: getCarPurchaseAvailableYears(),
            value: _.get(vehicleVM, 'purchaseDate_ML.year.value'),
            onValueChange: updatePurchaseDate,
            visible: !showPurchaseDateMonths() && (isPrivatePassenger() || isCollectible()),
            label: translator(messages.vehiclePurchaseYear)
        },
        // TODO: update to MonthYear picker in Jutro 7.2 (Elysian)
        purchaseDateField: {
            value: _.get(vehicleVM, 'purchaseDate_ML.value'),
            onBlur: updatePurchaseDate,
            visible: showPurchaseDateMonths() && (isPrivatePassenger() || isCollectible()),
            label: translator(messages.vehiclePurchaseMonth),
            placeholder: "MM/YYYY",
        },
        purchasedLessThan6Months: {
            visible: showOwnedLessThan6Months
        },
        annualMileageContainer: {
            visible: isAnnualMileageRequiredByType(),
            readOnly: isDisputedVendorMileage(),
            value: annualMileageValue()
        },
        annualMileageField: {
            required: _.get(vehicleVM, 'isAnnualMileageRequired_ML.value', false) && isModernProductPersonalAuto
        },
        parkingTypeContainer: {
            visible: !isOtherPersonallyRegistered() && isWhereParkedRequired()
        },
        purchaseDateInputField: {
            visible: isModernProductPersonalAuto,
            onChange: handleDateChange,
            value: vehiclePurchaseDateValue,
            stateMessages: {
                error: checkDate(vehiclePurchaseDateValue) ? [translator(messages.purchaseDateInputErrorMessage)] : []
            },
            onValidate
        },
        selectFuelType: {
            visible: isModernProductPersonalAuto,
        },
        agreedValueContainer: {
            visible: isModernProductPersonalAuto && isVehicleYearPre1981()
        },
        vehiclePrimaryUseContainerNP: {
            visible: isModernProductPersonalAuto && isPrivatePassengerNP()
        },
        vehiclePrimaryUseNP: {
            value: _.get(vehicleVM, 'primaryUse.value'),
            availableValues: primaryUseAvailableValues
        },
        conditionField: {
            value: _.get(vehicleVM, 'condition_ML.value.code')
        },
        registredOwnersField: {
            visible: isModernProductPersonalAuto,
        }
    };

    const resolvers = {
        resolveCallbackMap: {
            onValidate: onValidate
        },
        resolveComponentMap: {
            DateInput,
             mlparegisteredOwners: (props) => (
                <MLPARegisteredOwnersComponent
                    {...props}
                    drivers={drivers}
                    registeredOwnersValue={registeredOwnersValue}
                    onChange={handleOwnerChange}
                />
            )
        }
    }

    return (
        <ViewModelForm
            model={vehicleVM}
            uiProps={metadata.pageContent}
            overrideProps={overrideProps}
            callbackMap={resolvers.resolveCallbackMap}
            componentMap={resolvers.resolveComponentMap}
            onValueChange={handleValueChange}
            onModelChange={handleVehicleModelChange}
            onValidationChange={onValidate}
            showErrors={showValidationErrors}
        // showOptional for debugging if field should be required but not working properly
        // showOptional={true}
        />
    );
}

MLCRVehiclesNonDiscrepanciesComponent.propTypes = {
    vehicleVM: PropTypes.shape({}).isRequired
};

MLCRVehiclesNonDiscrepanciesComponent.defaultProps = {
    vehicleVM: {}
};
export default withRouter(MLCRVehiclesNonDiscrepanciesComponent);
